import type { JSX } from 'preact';

type Props = { class?: string; short?: boolean; style?: JSX.CSSProperties };

/** Hairline divider with a brass lozenge at its centre. */
export function Rule({ class: className = '', short = false, style }: Props) {
  return (
    <div class={`rule ${short ? 'rule--short' : ''} ${className}`} style={style} aria-hidden="true">
      <span class="rule__mark" />
    </div>
  );
}
